(function () {
  var MarkerLabelColumnGenerator = function (batchGeoTable) {
    var labelType = batchGeoTable.options.data.labeltype_sel;
    // var markers = window.batchGeoGoogleMapsMarker.getMarkersObjArray();

    /**
     * Returns a boolean of true if the labelType from labeltype_sel is a valid
     * type that can it's own column.
     *
     * @return {boolean} Returns true if the labelType is supported
     */
    var supportedLabel = function () {
      return labelType == "numbers" || labelType == "letters";
    };

    /**
     * Given an array of rows and the map's selected label type it will
     * return true if the total rows exceeds the limit for that specific
     * type of label. For example, if there's >=27 rows and the label type
     * is letters it will return true. If it's 10 it will return false.
     *
     * @param {array} rows An array of table rows. The function only cares
     * about length so it can just be an array containing anything that
     * represents your rows.
     *
     * @returns {boolean} True if over the limit for a particular label type
     */
    var atLabelTypeCountLimit = function (rows) {
      return (
        (rows.length > 99 && labelType === "numbers") ||
        (rows.length > 26 && labelType === "letters")
      );
    };

    /**
     * Returns the label for a given index and labelType. For example, if you
     * give it an index of 2 and labelType of number it'll give you back "3" and
     * if you gave it an index of 2 and the labelType was letters it'd give you
     * the letter "C". It also makes sure it can label them all. For example if
     * you give it 27 rows and index 2 while it's a letter label type it will
     * send an empty string back since there is no 27th letter.
     *
     * @param {array} row Will determine label based on how many rows plus
     * the label type. Usually you want to send the rows to be displayed not
     * all rows.
     * @param {number} index The index of the label you want to get back
     *
     * @return {string} Will give back a string of a number or letter depending
     * on what labelType is set
     */
    var determineLabel = function (rows, index) {
      if (!rows || atLabelTypeCountLimit(rows)) {
        return "";
      } else {
        return labelType == "numbers"
          ? index + 1
          : "ABCDEFGHIJKLMNOPQRSTUVWXYZ".slice(index, index + 1);
      }
    };

    /**
     * Given a collection of data and an array of IDs to filter by, this
     * function will give back a new array of IDs that you can use to determine
     * which cells to put a label in.
     *
     * @param {array} dataForLabels Pass *all* data you have for your markers
     * here. So if you have 100 markers this would be expecting 100 items.
     * @param {array} filteredRows Array of IDs to filter the dataForLabels by
     *
     * @return {array} An array of IDs
     */
    var getFilteredRowIds = function (dataForLabels, filteredRows) {
      if (!filteredRows || !filteredRows.length) {
        return dataForLabels.map(function (row) {
          return row.id;
        });
      } else {
        return filteredRows.map(function (id) {
          return parseInt(id);
        });
      }
    };

    /**
     * Given a collection of data and an array of IDs to filter down to, this
     * function will return an array of data that you can inject with
     * BatchGeoTable's addColumn function.
     *
     * @param {array} dataForLabels Pass *all* data you have for your markers
     * here. So if you have 100 markers this would be expecting 100 items.
     * @param {array} filteredRows Array of IDs to filter the dataForLabels by
     */
    var setLabels = function (dataForLabels, filteredRows) {
      var markerColumnId = 0;
      var filteredRowIds = getFilteredRowIds(dataForLabels, filteredRows);
      // For every row (not every marker!)...
      return dataForLabels.map(function (row, i) {
        // Check if the filteredRowIds contains the current marker data from
        // dataFromLabels. If it does NOT then return an empty string for this
        // item, otherwise figure out what label should be placed by calling the
        // determineLabel function
        var rowIndex = filteredRowIds.indexOf(batchGeoTable.data.rows[i].id);
        return rowIndex > -1
          ? determineLabel(filteredRowIds, markerColumnId++)
          : "";
      });
    };

    /**
     * Generates the new Marker column with the row data from BatchGeoTable
     */
    var injectMarkerLabelData = function () {
      if (!supportedLabel()) return;
      batchGeoTable.addColumn("Marker", setLabels(batchGeoTable.data.rows), 0);
    };

    /**
     * Updates the Marker column that was created with injectMarkerLabelData and
     * can filter the rows given a set of rows. If the table only has rows 1-10
     * you can pass those rows to this and itll only update the column from rows
     * 1-10.
     *
     * @param {array} filteredRows An array of IDs to filter down the column
     */
    var refreshMarkerLabelData = function (filteredRows) {
      if (!supportedLabel()) return;
      batchGeoTable.updateColumn(
        setLabels(batchGeoTable.data.rows, filteredRows),
        0,
      );
    };

    // future notifications if a new label type is added
    if (
      !labelType ||
      (labelType !== "numbers" &&
        labelType !== "letters" &&
        labelType !== "plain")
    ) {
      console.info("Unknown label type, marker label column not created");
    }
    // label is numbers or letters, proceed
    else if (supportedLabel()) {
      injectMarkerLabelData();
    }

    // Public API
    return {
      refreshMarkerLabelData: refreshMarkerLabelData,
      injectMarkerLabelData: injectMarkerLabelData,
    };
  };

  window.MarkerLabelColumnGenerator = MarkerLabelColumnGenerator;
})(window);
